import React from 'react';
import '../styles/components/InsightCard.css';

interface SWOTItem {
  id: number;
  finding: string;
  swot_type_id: number;
  section_id?: number;
}

interface InsightCardProps {
  swotItems: SWOTItem[];
  title?: string;
}

const InsightCard: React.FC<InsightCardProps> = ({ swotItems, title = "Section Insights" }) => {
  if (!swotItems || swotItems.length === 0) return null;

  const getInsightTypeLabel = (swotTypeId: number) => {
    switch (swotTypeId) {
      case 1: return 'Strength';
      case 2: return 'Weakness';
      case 3: return 'Opportunity';
      case 4: return 'Threat';
      default: return 'Insight';
    }
  };

  const getInsightColor = (swotTypeId: number) => {
    switch (swotTypeId) {
      case 1: return 'theme-success'; // Strength = success (green)
      case 2: return 'theme-danger';  // Weakness = danger (red)
      case 3: return 'theme-warning'; // Opportunity = warning (yellow)
      case 4: return 'theme-danger';  // Threat = danger (red)
      default: return 'theme-warning';
    }
  };

  return (
    <div className="insight-card-container">
      <div className="card-header">
        <span className="material-icons">insights</span>
        <span className="card-title">{title}</span>
      </div>
      <div className="card-content">
        {swotItems
          .sort((a, b) => {
            // Custom sort order: Strength (1), Opportunity (3), Weakness (2), Threat (4)
            const order = { 1: 0, 3: 1, 2: 2, 4: 3 };
            return (order[a.swot_type_id as keyof typeof order] || 0) - (order[b.swot_type_id as keyof typeof order] || 0);
          })
          .map(item => (
            <div key={item.id} className="insight-card">
              <div className="insight-content">
                <div className="insight-text">{item.finding}</div>
              </div>
              <div className={`insight-label ${getInsightColor(item.swot_type_id)}`}>
                {getInsightTypeLabel(item.swot_type_id)}
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default InsightCard;
